import { useLocation, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { diagnostic } from "@/lib/home-content";

export function DiagnosticCta({
    className = "",
    fullWidth = false,
    size = "md",
    testId = "diagnostic-cta",
}) {
    const location = useLocation();
    const navigate = useNavigate();
    const sizing =
        size === "lg"
            ? "px-7 py-3.5 text-base"
            : size === "sm"
              ? "px-5 py-2.5 text-sm"
              : "px-6 py-3.5 text-base";

    const go = () => {
        if (location.pathname === "/") {
            scrollToId("#contact");
            return;
        }
        navigate("/#contact");
    };

    return (
        <button
            type="button"
            data-testid={testId}
            onClick={go}
            className={`group inline-flex items-center justify-center gap-2 rounded-full bg-[var(--brand)] font-semibold text-white shadow-[0_12px_28px_rgba(43,80,255,0.38)] transition-transform hover:-translate-y-0.5 active:translate-y-0 ${sizing} ${
                fullWidth ? "w-full" : ""
            } ${className}`}
        >
            {diagnostic.label}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </button>
    );
}

export function DiagnosticHint({ className = "" }) {
    return (
        <p className={`text-sm leading-relaxed text-[#6b6b75] ${className}`}>{diagnostic.hint}</p>
    );
}
